/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import useContact from './useContact';

const ContactList = ({ pedagogicData, setPedagogicData, companyId }) => {
  const { updateContact, deleteContact } = useContact(companyId, pedagogicData, setPedagogicData);
  return (
    <MaterialTable
      title="Liste des référents"
      columns={[
        {
          title: 'Nom',
          field: 'name',
          sorting: true,
          defaultSort: 'asc',
        },
        {
          title: 'Prénom',
          field: 'firstname',
        },
        {
          title: 'Email',
          field: 'email',
        },
        {
          title: 'Téléphone',
          field: 'phone',
        },
      ]}
      data={pedagogicData}
      style={{
        width: '100%',
        fontSize: '13px',
        color: '#4b4b4b',
      }}
      options={{
        sorting: true,
        pageSize: 10,
        pageSizeOptions: [5, 10, 20],
      }}
      localization={{
        header: {
          actions: '',
        },
        toolbar: {
          searchPlaceholder: 'Rechercher..',
        },
        body: {
          emptyDataSourceMessage: 'Aucun contact pédagogique.',
          editRow: {
            deleteText: 'Archiver ce contact ?',
          },
          deleteTooltip: 'Supprimer',
        },
      }}
      editable={{
        onRowDelete: (oldData) => new Promise((resolve) => {
          deleteContact(oldData._id)
            .then(() => {
              resolve();
            });
        }),
        onRowUpdate: (newData) => new Promise((resolve) => {
          updateContact(newData);
          resolve();
        }),
      }}
    />
  );
};

ContactList.propTypes = {
  pedagogicData: PropTypes.array.isRequired,
  setPedagogicData: PropTypes.func.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default ContactList;
